import { render, staticRenderFns } from "./RecommendationStatusRow.vue?vue&type=template&id=64887503&scoped=true"
import script from "./RecommendationStatusRow.vue?vue&type=script&lang=js"
export * from "./RecommendationStatusRow.vue?vue&type=script&lang=js"
import style0 from "./RecommendationStatusRow.vue?vue&type=style&index=0&id=64887503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64887503",
  null
  
)

export default component.exports